import { ModalController } from "./modal_controller";

/**
 * 確認モーダル
 * @example
 * <div data-controller="confirm">
 *  <dialog data-confirm-target="dialog">
 *   <button data-action="confirm#cancel">cancel</button>
 *   <button data-action="confirm#confirm">OK</button>
 *  </dialog>
 * </div>
 * @example
 * 他のコントローラーからoutlet経由で呼び出す
 * async confirm() {
 *   if (await this.confirmOutlet.show()) {
 *     console.log("OK");
 *   } else {
 *     console.log("Cancel");
 *   }
 * }
 */
export class ConfirmController extends ModalController {
  #resolve;
  #reject;

  disconnect() {
    super.disconnect();
    if (this.#resolve) this.#resolve();
  }

  show() {
    super.show();
    return new Promise((resolve, reject) => {
      this.#resolve = resolve;
      this.#reject = reject;
    });
  }

  /**
   * @example
   * <button data-action="confirm#confirm">OK</button>
   * <button data-action="confirm#confirm" data-confirm-value-param="はい">はい</button>
   */
  confirm(event) {
    super.close();
    const value = event.params?.value || true;
    this.#resolve(value);
  }

  close() {
    super.close();
    this.#resolve(false);
  }

  cancel() {
    this.close();
  }

  reject() {
    super.close();
    this.#reject();
  }
}
